import LangBitmapFontTextView, {
  LangBitmapOpts,
} from './LangBitmapFontTextView';
import { RenderContext } from '@play-co/timestep-core/lib/platforms/browser/RenderContext';
import { WebGLContext } from '@play-co/timestep-core/lib/platforms/browser/webgl/WebGLContext2D';
import { Color, MultiplyFilter } from '@play-co/timestep-core/ui';

type ShadowOpts = {
  textShadowColor?: string | Color;
  textShadowOpacity?: number;
  textShadowOffsetX?: number;
  textShadowOffsetY?: number;
};

export type LangBitmapFontTextShadowViewOpts = LangBitmapOpts & ShadowOpts;

export class LangBitmapFontTextShadowView extends LangBitmapFontTextView {
  private shadowFilter: MultiplyFilter;
  private textShadowOpacity: number;
  private textShadowOffsetX: number;
  private textShadowOffsetY: number;

  constructor(opts: LangBitmapFontTextShadowViewOpts) {
    super(opts);

    this.shadowFilter = new MultiplyFilter(opts.textShadowColor || '#000000');
    this.textShadowOpacity = opts.textShadowOpacity ?? 1;
    this.textShadowOffsetX = opts.textShadowOffsetX ?? 3;
    this.textShadowOffsetY = opts.textShadowOffsetY ?? 3;
  }

  public updateShadow(opts: ShadowOpts) {
    this.shadowFilter.update(new Color(opts.textShadowColor || '#000000'));
    this.textShadowOpacity = opts.textShadowOpacity ?? this.textShadowOpacity;
    this.textShadowOffsetX = opts.textShadowOffsetX ?? this.textShadowOffsetX;
    this.textShadowOffsetY = opts.textShadowOffsetY ?? this.textShadowOffsetY;
  }

  public render(context: RenderContext) {
    if (context instanceof WebGLContext) {
      const { _colorFilter } = this;
      const { globalAlpha } = context;

      this._colorFilter = this.shadowFilter;
      context.globalAlpha *= this.textShadowOpacity;
      const { transform } = context;
      transform.tx += this.textShadowOffsetX;
      transform.ty += this.textShadowOffsetY;
      super.render(context);

      this._colorFilter = _colorFilter;
      context.globalAlpha = globalAlpha;
      transform.tx -= this.textShadowOffsetX;
      transform.ty -= this.textShadowOffsetY;
    }
    super.render(context);
  }
}
